module.exports = __webpack_public_path__ + "static/media/phone.cfb8e28f.svg";